<template>
	<div class="nk-tree d-flex flex-column h-100" @focus="elFocused" :tabindex="tabindex" tabscope>
		<div class="tree-filter pb-3" v-if="settings.enableSearch">
			<icon icon="search" />
			<nk-input class="filter-input form-control" :options="inputOptions()" v-model="searchKeyword" @update:modelValue="searchKeywordChanged"></nk-input>
		</div>
		<div class="tree-canvas h-100 overflow-hidden" style="height: max-content;" tabindex="0" ref="canvas">
			<nk-sub-tree ref="subtree" :height="height" :key="height" :data="filteredNodes" :expands="expandeds" :depth="0" :settings="settings" :selected="selectedItem" @nodeSelected="(val) => onNodeSelected(val, true)" @nodeStateChanged="onNodeStateChanged" @nodeDblClicked="n => $emit('nodeDblClicked', n)" v-if="visible" startup>
			</nk-sub-tree>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import $sc from '~/plugins/shortcut.collection.js'
	import { isEmpty } from '../../statics/validators'

	export default {
		props: {
			options: {},
			data: { type: Array, default: () => ([]) },
			tabindex: {},
			selected: { type: Object }
		},
		emits: ['setSelected', 'nodeDblClicked'],
		data() {
			return {
				maxScrollGodFather: 0,
				searchTimeOut: null,
				height: 0,
				expandeds: [],
				visible: true,
				settings: {},
				defaults: {
					treeNodes: null,
					editable: false,
					rootId: 0,
					baseLevel: 0,
					maxLevel: 9,

					defaultSortByFields: ['level', 'id'],

					filterItem: [],
					enableSearch: false,
					searchResultText: 'Number of matched items: ',
					noDataMessage: 'داده ای وجود ندارد.',
					searchPlaceholder: 'جستجو',

					nodeCustomClass: null,

					setTitle: undefined,
					// custom events
					onNodeClicked: undefined,
					onNodeDblClicked: undefined,
					onNodeSelected: undefined,
					onNodeAddClicked: undefined,
					onNodeEditClicked: undefined,
					onNodeDeleteClicked: undefined,
					buttons: []
				},
				configs: {
					filterType: 0,

					selectedChild: 'selected',

					searchText: '',
					searchMode: false,
					foundNodesNumber: 0,

					expandLevel: 0
				},
				treeNodes: [],
				searchKeywordLocal: '',
				disabledTree: false,
				selectedItem: null
			}
		},
		watch: {
			data: {
				deep: true,
				handler(val) {
					this.prepareData(val)
				},
			},
			selected: {
				handler(val) {
					console.log('watch selected', val)
					if (val !== this.selectedItem) {
						this.selectNode(val, true, false, true)
					}
				}
			},
			// subTreeRendered:{
			// 	handler(){
			// 		console.log('subTree rendered',this.$refs.canvas.clientHeight)
			//
			// 	}
			// }
		},
		computed: {
			searchKeyword: {
				get() {
					return this.searchKeywordLocal
				},
				set(val) {
					this.delayedInputSearchKeyword(val)
				}
			},
			filteredNodes() {
				// console.log('filterNodes')
				const words = this.searchKeywordLocal.getWords()
				// console.log('words', words)
				let fields = this.settings.searchableFields
				let filtered = this.treeNodes
				if (fields == null || !$.isArray(fields) || fields.length === 0) {
					fields = ['name']
				}


				if (words.length > 0) {
					filtered = filtered.filter((x) => fields.some(y => words.every(word => typeof x[y] === 'number' ? x[y].toString().includes(word) : x[y].includes(word))))

					const addParent = (node) => {
						if (!isEmpty(node.parent?.id)) {
							var parent = this.treeNodes.find(x => x.id === node.parent.id)
							if (parent != null) {
								if (filtered.tryPush(parent, (a, b) => a.id === b.id)) {
									addParent(parent)
								}
							}
						}
					}

					// find parents
					for (let node of filtered) {
						addParent(node)
					}
					// expand all parents
					let parents = filtered.filter(x => x.hasChild)
					for (let p of parents) {
						if (filtered.find(x => x.parent?.id === p.id)) {
							this.expandNode(p)
						} else {
							this.collapseNode(p)
						}
					}
				}

				return filtered
			}
		},
		created() {
			console.log('data', this.data)
			this.delayedInputSearchKeyword = _.debounce(this.delayedInputSearchKeyword, 400)
			this.settings = $.extend({}, this.defaults, this.options)
			this.prepareData(this.data)
		},
		mounted() {
			// console.log('mounted')
			// console.log('canvas', this.$refs.canvas)
			this.defer(() => {
				// console.log('canvas.clientHeight', this.$refs.canvas.clientHeight)
				this.height = this.$refs.canvas.clientHeight
				this.calculateGodfatherMaxScroll()
			}, 1)

			this.defer(this.drawDisabledLayer, 5)
		},
		updated() {
			this.defer(this.drawDisabledLayer, 5)
		},
		methods: {
			calculateGodfatherMaxScroll() {
				// console.log('calculateGodfatherMaxScroll')
				const godfather = this.$refs.canvas.querySelector(`[id^="godFather"]`)
				const currentScrollTop = godfather.scrollTop
				// console.log('currentScrollTop',currentScrollTop)
				godfather.scrollTop = 50000
				this.maxScrollGodFather = godfather.scrollTop
				// console.log('maxScrollGodFather',this.maxScrollGodFather)
				godfather.scrollTop = currentScrollTop
				// console.log('currentScrollTop2',godfather.scrollTop)

			},
			getChildren(parentId) {
				return this.data.filter((x) => x.parent && x.parent.id === parentId)
			},
			inputOptions() {
				return {
					placeholder: this.settings.searchPlaceholder,
					mode: 'text'
				}
			},
			prepareData(data) {
				if (data == null) {
					data = []
				}

				data = data.map(item => {

					// collapsing nodes that don't have children
					// if (!this.getChildren(item.id).length && this.expandeds.includes(item.id)) {
					// 	var index = this.expandeds.indexOf(item.id)
					// 	this.expandeds.splice(index, 1)
					// }

					// to support old naming rules
					return _.merge({
						hasChild: item.treeHasChild,
						level: item.treeLevel
					}, item)
				})

				const sort = (a, b) => {
					var res = 0

					if (this.settings.defaultSortByFields.length > 0) {
						for (let i = 0; i < this.settings.defaultSortByFields.length && res === 0; i++) {
							let field = this.settings.defaultSortByFields[i]
							res = (_.get(a, field) < _.get(b, field)) ? -1 : res
							res = (_.get(a, field) > _.get(b, field)) ? 1 : res
						}

						return res
					} else {
						res = (a.level < b.level) ? -1 : res
						res = (a.level > b.level) ? 1 : res
						if (res !== 0) {
							return res
						}

						res = (a.id < b.id) ? -1 : res
						res = (a.id > b.id) ? 1 : res

						return res
					}
				}

				data = data || []
				this.treeNodes = data.sort(sort)

				this.searchKeywordLocal = ''

				let nodeToSelected = this.selectedItem || _.head(this.treeNodes.filter(x => x.level === 1))
				console.log('nodeToSelected', nodeToSelected)
				nodeToSelected && this.selectNode(nodeToSelected, !this.selectedItem)
				// this.defer(() => this.height = this.$refs.canvas.clientHeight, 100)

			},
			onNodeSelected(node, selectedWithMouse) {
				if (!node) {
					return
				}

				this.selectNode(node, true, selectedWithMouse)
			},
			onNodeStateChanged(node) {
				node = this.filteredNodes.find(x => x.id === node.id)
				if (node == null) {
					return
				}

				this.switchState(node)
			},

			selectNode(selected, emit, selectedWithMouse, autoSelected) {
				if (selected?.parent && selected.parent.id) {
					selected.parent.hasChild = true
					this.expandNode(selected.parent)
				}
				this.$nextTick(() => {
					if (!selected || selected === this.selectedItem) {
						return
					}
					!selectedWithMouse && this.scrollToNode(selected)
					this.selectedItem = selected


					if (emit === true) {
						this.$emit('setSelected', selected)
					}
				})
			},
			expandNode(node) {
				if (!node.hasChild)
					return

				this.expandeds.push(node.id)
			},
			collapseNode(node) {
				this.expandeds = this.expandeds.filter(x => x !== node.id)
			},
			switchState(node) {
				// console.log('switchState node',this.expandeds,node)

				if (this.expandeds.includes(node.id))
					this.collapseNode(node)
				else
					this.expandNode(node)
			},
			elFocused() {
				var tree = $(this.$el).find('.tree-canvas')
				if (tree.length) {
					tree[0].focus()
				}
			},
			searchKeywordChanged() {
				if (this.searchKeywordLocal === '') {
					let parents = this.filteredNodes.filter(x => x.hasChild === true)
					for (let p of parents) {
						this.collapseNode(p)
					}

					let nodeToSelected = this.selectedItem || _.head(this.treeNodes.filter(x => x.level === 1))
					this.selectNode(nodeToSelected)
				}
			},
			delayedInputSearchKeyword(val) {
				clearTimeout(this.searchTimeOut)
				this.searchTimeOut = setTimeout(() => {
					val === '' && (this.expandeds = [])
					this.searchKeywordLocal = val
				}, 500)
			},

			getParent(node) {
				if (node && node.parent && node.parent.id) {
					return _.head(this.filteredNodes.filter(x => x.id === node.parent.id))
				}
			},
			getParents(node) {
				let list = []

				const iterate = n => {
					list.push(n)
					if (n.parent && !isEmpty(n.parent.id)) {
						iterate(n.parent)
					}
				}

				if (node && node.parent && !isEmpty(node.parent.id)) {
					iterate(node.parent)
				}

				return list
			},
			nextNodeInTree() {
				var node = this.selectedItem
				if (node == null) {
					return
				}

				let children = this.filteredNodes.filter(x => x.parent && x.parent.id === node.id)

				if (this.expandeds.includes(node.id) && children.length > 0) {
					let index = children.indexOf(node)
					return children[index + 1]
				} else {
					let levelmates = this.filteredNodes.filter(x => !x.parent === !node.parent && (!x.parent || x.parent.id === node.parent.id) && x.level === node.level)
					let index = levelmates.findIndex(val => val.id === node.id)

					if (index < levelmates.length - 1) { // not last
						return levelmates[index + 1]
					} else { // last, go upper
						const nextIndexParent = (n) => {
							let parent = this.getParent(n)
							if (parent) {
								let uppers = this.filteredNodes.filter(x => !x.parent === !parent.parent && (!x.parent || x.parent.id === parent.parent.id) && x.level === parent.level)
								let index = uppers.indexOf(parent)
								if (index < uppers.length - 1) {
									return uppers[index + 1]
								} else {
									return nextIndexParent(parent)
								}
							}
						}

						return nextIndexParent(node)
					}
				}
			},
			prevNodeInTree() {
				var node = this.selectedItem
				if (node == null) {
					return
				}

				let levelmates = this.filteredNodes.filter(x => !x.parent === !node.parent && (!x.parent || x.parent.id === node.parent.id) && x.level === node.level)
				let index = levelmates.findIndex(val => val.id === node.id)

				if (index > 0) { // not first
					let prev = levelmates[index - 1]
					const lastChildOfPrev = (n) => {
						if (!this.expandeds.includes(n.id)) {
							return n
						} else if (n.hasChild === true) {
							var children = this.filteredNodes.filter(x => x.parent && x.parent.id === n.id)
							if (children.length > 0) {
								return lastChildOfPrev(children[children.length - 1])
							} else {
								return n
							}
						} else {
							this.logger.error('a node with hasChild=false doesn\'t expand')
						}
					}

					return lastChildOfPrev(prev)
				} else { // first, go upper
					return this.getParent(node)
				}
			},
			scrollToNode(node) {
				const scrollTo = (parentNode, godfather) => {
					let foundNode = parentNode.querySelector(`li[data-key='${node.id}'] > .tree-group-item`)
					if (foundNode) foundNode.scrollIntoView({ block: 'end' })
					else {
						parentNode.scrollIntoView({ block: 'start' })
						this.defer(() => {
							$(parentNode).animate({ scrollTop: parentNode.scrollHeight + 1000000 }, "fast")
							this.defer(() => {
								let foundNodeAgain = parentNode.querySelector(`li[data-key='${node.id}'] > .tree-group-item`)
								foundNodeAgain && foundNodeAgain.scrollIntoView({ block: 'end' })
							}, 1)
						}, 100)


						// this.defer(()=>{
						//
						// 	let foundNodeAgain = parentNode.querySelector(`li[data-key='${node.id}'] > .tree-group-item`)
						// 	console.log('foundNodeAgain',foundNodeAgain)
						// 	foundNodeAgain && foundNodeAgain.scrollIntoView({ block : 'end'})
						// },1000)
					}
				}
				this.defer(() => {
					const godfather = this.$refs.canvas.querySelector(`[id^="godFather"]`)

					const fatherChildParent = this.$refs.canvas.querySelector(`#a${node?.parent?.id}`)
					if (fatherChildParent?.scrollHeight > fatherChildParent?.clientHeight) {
						scrollTo(fatherChildParent, godfather)
					} else {
						scrollTo(godfather)
					}
				}, 1)

				//
				// let $scroller = $(godfather)
				// console.log('$scroller',$scroller)
				// let $node
				// if (node) {
				// 	$node = $scroller.find(`li[data-key=${node.id}] > .tree-group-item`)
				// } else {
				// 	$node = $scroller.find('li.selected > .tree-group-item')
				// }
				// console.log('$node',$node)
				// $scroller.scrollTo($node)
			},
			drawDisabledLayer() {
				var jel = $(this.$el)
				if (typeof jel.attr('disabled') !== 'undefined' || jel.parents('[disabled]').length > 0) {
					this.disabledTree = true
				} else {
					this.disabledTree = false
				}
			},

			subscribeKeys() {
				var tree = $(this.$el).find('.tree-canvas')
				var filter = $(this.$el).find('.filter-input')

				this.$keyHandler.Subscribe({
					name: 'tree-arrow-left',
					keyCode: 37,
					el: tree,
					context: this,
					test: function () {
						return !this.disabledTree && this.selectedItem
					},
					handler: function () {
						var node = this.selectedItem

						if (!this.expandeds.includes(node.id)) {
							this.expandNode(node)
							return true

						} else if (node.hasChild) {
							var firstChild = _.head(this.filteredNodes.filter(x => x.parent && x.parent.id === node.id))

							if (firstChild) {
								this.onNodeSelected(firstChild)
							}
						}
					}
				}) // left key
				this.$keyHandler.Subscribe({
					name: 'tree-arrow-up',
					keyCode: 38,
					el: tree,
					context: this,
					test: function () {
						return !this.disabledTree
					},
					handler: function (mainElement, e) {
						var prevNode = this.prevNodeInTree()

						if (prevNode != null) {
							this.onNodeSelected(prevNode)
							return true
						} else {
							// first tree element
							if (this.settings.enableSearch) {
								$(this.$el).find('.filter-input').focus()
							}
						}
						return true
					}
				}) // up key
				this.$keyHandler.Subscribe({
					name: 'tree-arrow-right',
					keyCode: 39, // [32,39],
					el: tree,
					context: this,
					test: function () {
						return !this.disabledTree && this.selectedItem
					},
					handler: function (mainElement, e) {
						var node = this.selectedItem
						if (this.expandeds.includes(node.id)) {
							this.onNodeStateChanged(node)
							return true
						} else {
							var firstParent = _.head(this.filteredNodes.filter(x => node.parent && x.id === node.parent.id))
							if (firstParent) {
								this.onNodeSelected(firstParent)
								return true
							}
						}
					}
				}) // right key
				this.$keyHandler.Subscribe({
					name: 'tree-arrow-down',
					keyCode: 40,
					el: tree,
					context: this,
					test: function () {
						return !this.disabledTree
					},
					handler: function (mainElement, e) {
						var nextNode = this.nextNodeInTree()
						if (nextNode != null) {
							e.preventDefault()
							this.onNodeSelected(nextNode)
						}

						return true
					}
				}) // down key
				this.$keyHandler.Subscribe({
					name: 'tree-filter-arrow-down',
					keyCode: 40,
					el: filter,
					context: this,
					test: function () {
						return !this.disabledTree
					},
					handler: function (mainElement, e) {
						e.preventDefault()
						$($(this.$el).find('.tree-canvas')).focus()
						this.onNodeSelected(_.head(this.filteredNodes))
						return true
					}
				}) // down key - search
				this.$keyHandler.Subscribe({
					name: 'tree-filter-clear',
					keyCode: 27, // 27:escape
					el: filter,
					context: this,
					test: function () {
						return !this.disabledTree
					},
					handler: function (mainElement, e) {
						this.searchKeywordLocal = ''
						return true
					}
				}) // escape key - search
				this.$keyHandler.Subscribe({
					name: 'insert-account',
					shortcut: $sc.find('insert'),
					el: tree,
					context: this,
					test: function () {
						return !this.disabledTree && this.settings.editable
					},
					handler: function () {
						if (this.selectedItem) {
							this.settings.onNodeAddClicked(this.selectedItem)
							return true
						}
					}
				}) // insert
				this.$keyHandler.Subscribe({
					name: 'edit-account',
					shortcut: $sc.find('edit'),
					el: tree,
					context: this,
					test: function () {
						return !this.disabledTree && this.settings.editable
					},
					handler: function () {
						if (this.selectedItem) {
							this.settings.onNodeEditClicked(this.selectedItem)
							return true
						}
					}
				}) // edit
				this.$keyHandler.Subscribe({
					name: 'delete-account',
					shortcut: $sc.find('delete', 'account'),
					el: tree,
					context: this,
					test: function () {
						const nodeIsDeleteable = () => {
							if (this.selectedItem == null) {
								return false
							}

							return !this.selectedItem.hasChild
						}

						return !this.disabledTree && this.settings.editable && nodeIsDeleteable()
					},
					handler: function () {
						if (this.selectedItem) {
							this.settings.onNodeDeleteClicked(this.selectedItem)
							return true
						}
					}
				}) // delete
			}
		},
	}
</script>
<style src="~/styles/nikan-tree.less" lang="less"></style>
